import React, { useState, useMemo } from "react";
import DataTable from "components/DataTable";
import { useTableData } from "../../hooks/useTableData";
import { aepsReportsConfig } from "config/tableConfigs"; 
import PageWrapper from "components/PageWrapper";
import { AEPSReceiptModa } from "./AEPSReceipt";
import { fetchWrapper } from "utils/apiFetch";
import { useSession } from "hooks/useSession";

const AEPSReportsPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const [loading, setloading] = useState(false);
  const { userid, role } = useSession();
const userRole = role;

  
  const getLast7Days = () => {
    const today = new Date();
    const last7 = new Date();
    last7.setDate(today.getDate() - 1);
  
    return {
      start: last7.toISOString().split("T")[0],
      end: today.toISOString().split("T")[0],
    };
  };
  
  const { start, end } = getLast7Days();
  
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  
  const [apiUrl, setApiUrl] = useState(
    `https://api.mokshiq.in/get_aeps_report?user=${userid}&filter_date=${start}&end_date=${end}`
  );

  const tableData = useTableData(apiUrl, aepsReportsConfig);

  // ✅ VIEW RECEIPT HANDLER
  const handleView = async (report) => {
    try {
      setloading(true);

      if (!report?.refNo) {
        console.warn("No refNo found:", report);
        setloading(false);
        return;
      }

      const url = `https://api.mokshiq.in/show_receipt_aeps?id=${report.refNo}`;
      const response = await fetchWrapper(url);

      if (!response || !response.data) {
        console.error("No receipt data for:", report.refNo);
        setloading(false);
        return;
      }

      setReceiptData({
        ...response.data,
        ministatement: response.data?.ministatement || []
      });

      setShowModal(true);
    } catch (error) {
      console.error("Receipt fetch error:", error);
    } finally {
      setloading(false);
    }
  };

  // ✅ DATE FILTER HANDLER
  const handleDateFilter = (startDate, endDate) => {
    const newUrl = `https://api.mokshiq.in/get_aeps_report?user=${userid}&filter_date=${startDate}&end_date=${endDate}`;
    setApiUrl(newUrl);
  };

  // ✅ ROLE BASED COLUMN FILTERING
  const filteredConfig = useMemo(() => {
    const base = { ...aepsReportsConfig };

    // Map like recharge logic
    const roleColumnMap = {
      Retailer: [
        "id", "refNo", "ackNo", "transectionType", "bankName", "product",
        "number", "amount", "status", "createdAt", "openingBalanceBc",
        "bcCommission", "bcTds", "closingBalanceBc", "aadharNumber"
      ],

      Distributer: [
        "id", "refNo", "ackNo", "transectionType", "product", "amount", "bankName",
        "status", "createdAt", "openingBalanceDistributor", "commission",
        "tds", "charge", "closingBalanceDistributor", "aadharNumber"
      ],

      "Super Distributer": [
        "id", "refNo", "ackNo", "transectionType", "product", "amount", "bankName",
        "status", "createdAt", "openingBalanceSuperDistributor", "commission",
        "tds", "charge", "closingBalanceSuperDistributor", "aadharNumber"
      ],

      Admin: [
        "id", "refNo", "ackNo", "productType", "product", "amount", "bankName",
        "status", "createdAt", "openingBalanceAdmin", "commissionAdmin","tdsAdmin",
        "chargeAdmin", "closingBalanceAdmin", "openingBalanceBc","bcCommission",
        "bcTds", "closingBalanceBc", "aadharNumber"
      ],

     "Main Admin": [
  "id",
  "refNo",
  "ackNo",
  "productType",
  "product",
  "amount",
  "bankName",
  "status",
  "createdAt",
  "customerNo",
  "walletTxn",
  "txnFlow",
  "bankRrn",
  "aadharNumber",
  "description",

  // ===== Admin Wallet =====
  "openingBalanceAdmin",
  "commissionAdmin",
  "tdsAdmin",
  "chargeAdmin",
  "gstAdmin",
  "closingBalanceAdmin",

  // ===== BC Wallet =====
  "openingBalanceBc",
  "bcCommission",
  "bcTds",
  "bcCharge",
  "bcGst",
  "closingBalanceBc",

  // ===== Main Admin Wallet =====
  "openingBalanceMAdmin",
  "commissionMAdmin",
  "tdsMAdmin",
  "chargeMAdmin",
  "closingBalanceMAdmin"
]

    };

    const allowed = roleColumnMap[userRole] || [];

    base.columns = aepsReportsConfig.columns.filter(col =>
      allowed.includes(col.key)
    );

    return base;
  }, [userRole]);

  return (
    <div>
      {loading && (
        <div className="page-loader-overlay d-flex justify-content-center align-items-center"
             style={{
               position: "fixed",
               top: 0, left: 0,
               width: "100%", height: "100%",
               backgroundColor: "rgba(255,255,255,0.7)",
               zIndex: 3000
             }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <PageWrapper config={aepsReportsConfig} onDateFilter={handleDateFilter}>
        <DataTable
          config={filteredConfig}
          tableData={tableData}
          onView={handleView}
          onDelete={() => {}}
          onEdit={() => {}}
          onExport={() => {}}
          onDeleteSelected={() => {}}
        />
      </PageWrapper>

      <AEPSReceiptModa
        receiptData={receiptData}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title="AEPS Transaction Receipt"
      />
    </div>
  );
};

export default AEPSReportsPage;
